<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    import '../src/style/common_styles.scss';

    export default {
        name: 'app',
        data() {
            return {
                ticking: false,
                last_known_scroll_position: 0
            }
        },
        /*created: function(){
            document.addEventListener('scroll', this.onBodyScroll, {capture: true, passive: true});
        },
        destroyed: function () {
            document.removeEventListener('scroll', this.onBodyScroll);
        },
        methods: {
            onBodyScroll: function() {
                let vm = this;
                this.last_known_scroll_position = window.scrollY;

                console.log(this.ticking);

                if (!this.ticking)
                {
                    window.requestAnimationFrame(function(){
                        vm.$store.dispatch('setScrollOffsetY', vm.last_known_scroll_position, {root: true});
                        vm.ticking = false;
                    });

                   vm.ticking = true;
                }

                //this.$store.dispatch('setScrollOffsetY', window.scrollY, {root: true});
            }
        }*/
    }
</script>

<style lang="scss">
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html {
        font-size: 100%;
    }

    body {
        margin: 0;
    }

    input, textarea, select, button {
        font-family: Arial, sans-serif;
    }

    ::-webkit-scrollbar {
        width: 8px;
        border-radius: 8px;
        height: 12px;
        background-color: #9b9b9b;
    }

    ::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: #d8d8d8;
    }

    ::-webkit-scrollbar
    {
        width: 8px;
        border-radius: 8px;
        background-color: #9b9b9b;
    }

    ::-webkit-scrollbar-thumb
    {
        border-radius: 8px;
        -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.3);
        background-color: #9b9b9b;
    }

    button {
        font-size: 14px;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
    }

    #app {
        font-family: Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #212121;
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue